import { SVGProps } from 'react';

export const IconMarketing = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox='3 3 20 20' xmlns='http://www.w3.org/2000/svg'>
      <path d='M7 14.5H10V18C10 18.5523 9.55228 19 9 19H8C7.44772 19 7 18.5523 7 18V14.5Z' fill='currentColor' />
      <path d='M4 11C4 9.61929 5.11929 8.5 6.5 8.5H9V13.5H6.5C5.11929 13.5 4 12.3807 4 11Z' fill='currentColor' />
      <path
        d='M18 5.5169C18 5.23142 17.7686 5 17.4831 5C16.4826 5 15.5036 5.29037 14.6648 5.83589L12.491 7.24975C11.7253 7.74776 10.8975 8.14307 10.0289 8.42555L9.8 8.5V13.5C10.8206 13.8319 11.7932 14.2964 12.6928 14.8815L14.6648 16.1641C15.5036 16.7096 16.4826 17 17.4831 17C17.7686 17 18 16.7686 18 16.4831V5.5169Z'
        fill='currentColor'
      />
      <path d='M21 11C21 9.89543 20.1046 9 19 9V13C20.1046 13 21 12.1046 21 11Z' fill='currentColor' />
    </svg>
  );
};
